// extracted by mini-css-extract-plugin
export default {"addLink":"add_link_addLink__scU+q"};